import React, { PureComponent } from 'react';
import { LeftArrowShadow } from 'roomi/icons';
import classNames from 'classnames';

class SlickLeftArrow extends PureComponent {
  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  };

  render() {
    const { customClass, className, style, height, width } = this.props;
    return (
      <LeftArrowShadow
        onClick={this.handleClick}
        className={classNames(className, customClass)}
        style={{ height, width, ...style }}
      />
    );
  }
}

export default SlickLeftArrow;
